import DataObjectList from '../../../common/model/DataObjectList';

import DataChannel from './DataChannel';

export default class DataChannelList extends DataObjectList {
  getElementClassType() {
    return DataChannel;
  }
}